document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.drawer-menu');
  if (!drawer) return;

  const sync = () => {
    const open =
      drawer.classList.contains('active') &&
      drawer.classList.contains('visible');
    document.body.classList.toggle('menu-open', open);
  };

  sync();
  new MutationObserver(sync).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
  });
});